import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import { RefundFormModel } from '../Models/billdetail.model';
import * as moment from 'moment';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
@Component({
  selector: 'app-bill-refund',
  templateUrl: './bill-refund.component.html',
  styleUrls: ['./bill-refund.component.scss']
})
export class BillRefundComponent implements OnInit {
  RefundData: RefundFormModel = {};
  DipositeType: any = [];
  BnakType: any = [];
  PaymentType: any = [];
  RefundDataArray: any = [];
  updaterefund: boolean = true;
  dyanmiccheck: boolean = false;
  MinimeDate: any;
  cuurentTime: any;
  showspinner: boolean = false;
  checkmaxAmountrefund: number = 0;
  buttondisable: boolean = true;
  screenPermissionobj: any = {};
  isupdate: boolean = false;
  lockfield: boolean = true;
  refunddisable: boolean = false;
  getRefundReson: string = '';
  bankdetailelvel1: any = "Card/Cheque No.";
  bankdetailelvel2: any = "Card/Cheque Date";
  show: boolean = true;
  RefundId: any;
  constructor(public authService: AuthService, public dialog: MatDialog, public ipdService: IPDService,
    public dashboardService: DashboardService, private datePipe: DatePipe, public branchMatserService: BranchMatserService,
    public opdvisitService: OpdVisitService, public dialogRef: MatDialogRef<BillRefundComponent>,
    public router: Router, public billingservice: BillingserviceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    this.getdipaymenttype();
    this.getbanktype();
    this.setBillrefunddata(this.data);
    this.getBillrefundList(0, this.data.billId);
    this.MinimeDate = this.authService.getServerDate;
    this.getscreenPermission();
    this.getproductmasterconfig();
    this.getBranchDetail(this.authService.Loggeduser.branchid);
  }

  getscreenPermission() {
    this.screenPermissionobj = {};
    let userId = this.authService.Loggeduser.userid;
    this.dashboardService.subscriptions = this.billingservice.getbillingScreenPermission(userId).subscribe(data => {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.screenName.toLowerCase() === 'refund') {
          this.screenPermissionobj = element;
        }

      }
    })
  }
  checkNegative(value: any) {

    if (value >= 0) {
      return true
    } else {
      this.RefundData.RefundAmount = 0;
    }
  }

  getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find(fy => fy.pkFinYearId == finyearid).displayFinYear;
  }


  closedialog() {
    this.dialogRef.close(this.checkmaxAmountrefund);
  }
  getdiposittype() {
    this.dashboardService.subscriptions = this.billingservice.getdepositeType().subscribe(data => {

      this.DipositeType = data;
    })
  }

  getdipaymenttype() {
    this.dashboardService.subscriptions = this.billingservice.getpaymentType().subscribe(data => {

      this.PaymentType = data;
    })
  }

  getbanktype() {
    this.dashboardService.subscriptions = this.billingservice.getbankType().subscribe(data => {

      this.BnakType = data;
    })
  }

  getBillrefundList(flag, billid) {
    this.checkmaxAmountrefund = 0;

    this.RefundDataArray = [];
    this.dashboardService.subscriptions = this.billingservice.getBillRefundList(flag, billid).subscribe(item => {
      if (item.statusCode) {

      } else {
        var totalfefund = 0
        this.RefundDataArray = item;
        this.RefundDataArray.forEach(dataa => {
          totalfefund = totalfefund + dataa.refundAmount;
        });
        this.checkmaxAmountrefund = totalfefund;
        if (this.RefundData.PK_TranID_Approval == null) {
          this.RefundData.RefundAmount = this.RefundData.CurrencyAmount - totalfefund;
        }

      }
    })
  }
  setBillrefunddata(data: any) {

    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.RefundData.FK_BranchId = this.opdvisitService.patientdetails.fkBranchId;
    this.RefundData.RefundType = 'B'
    const currentdate = this.authService.getServerDate;
    if (data.refundDate == undefined && data.refundTime == undefined) {
      this.RefundData.RefundDate = this.datePipe.transform(currentdate, "yyyy-MM-dd");
      this.RefundData.RefundTime = this.cuurentTime;
    } else {
      this.RefundData.RefundDate = this.datePipe.transform(data.refundDate, "yyyy-MM-dd");
      this.RefundData.RefundTime = data.refundTime;
    }

    this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
    this.RefundData.RefundReason = null;
    this.RefundData.FK_PayTypeId = 1;
    this.RefundData.FK_CurrencyId = 1;
    if (this.data.appprvaldetail.pK_TranID > 0) {
      this.RefundData.CurrencyAmount = this.data.appprvaldetail.approvedAmount;
      this.RefundData.RefundAmount = this.data.appprvaldetail.approvedAmount;
    } else {
      this.RefundData.CurrencyAmount = data.paidAmount;
      this.RefundData.RefundAmount = data.paidAmount;
    }

    this.RefundData.ConvertRetio = 1;

    this.RefundData.ChequeNo = null;
    this.RefundData.ChequeDate = null;
    this.RefundData.FK_ChqBankId = null;
    this.RefundData.ReferenceNo = null;
    this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.RefundData.IsActive = 1;
    this.RefundData.PK_RefundId = 0;

    if (this.RefundData.FK_PayTypeId === 2 || this.RefundData.FK_PayTypeId === 3 || this.RefundData.FK_PayTypeId === 6) {
      this.dyanmiccheck = true;
    }
    if (this.data.appprvaldetail.pK_TranID > 0) {
      this.RefundData.PK_TranID_Approval = this.data.appprvaldetail.pK_TranID;
      this.RefundData.requestUsed = 1;
      this.RefundData.RefundAmount = this.data.appprvaldetail.approvedAmount;
    } else {

      this.RefundData.requestUsed = null;
      this.RefundData.PK_TranID_Approval = null;
    }
  }
  savebillRefunddetails() {

    if (this.RefundData.RefundReason) {
      if (this.RefundData.FK_PayTypeId > 1 && this.RefundData.FK_PayTypeId != 7) {
        if ((this.RefundData.ChequeNo == null || this.RefundData.ChequeNo == "") || (this.RefundData.ChequeDate == null || this.RefundData.ChequeDate == "") || (this.RefundData.FK_ChqBankId == null || this.RefundData.FK_ChqBankId == "")) {
          this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
          return;
        }
      } else if (this.RefundData.FK_PayTypeId == 7) {
        if ((this.RefundData.ChequeNo == null || this.RefundData.ChequeNo == "") || (this.RefundData.ChequeDate == null || this.RefundData.ChequeDate == "")) {
          this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
          return;
        }
      }
      this.buttondisable = false;

      this.cuurentTime = new Date().toTimeString().split(" ")[0];
      this.RefundData.FK_ReceiptId = 0;
      this.RefundData.FK_BranchId = parseInt(this.RefundData.FK_BranchId);
      this.RefundData.RefundType = this.RefundData.RefundType;
      const currentdate = this.authService.getServerDate;
      this.RefundData.RefundDate = this.datePipe.transform(currentdate, "yyyy-MM-dd");
      this.RefundData.RefundTime = this.cuurentTime;
      this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
      this.RefundData.RefundReason = this.RefundData.RefundReason;
      this.RefundData.ReferenceNo = this.RefundData.ReferenceNo;
      this.RefundData.FK_PayTypeId = parseInt(this.RefundData.FK_PayTypeId);
      this.RefundData.FK_CurrencyId = parseInt(this.RefundData.FK_CurrencyId)
      this.RefundData.CurrencyAmount = parseInt(this.RefundData.CurrencyAmount);
      this.RefundData.ConvertRetio = parseInt(this.RefundData.ConvertRetio);
      this.RefundData.RefundAmount = parseInt(this.RefundData.RefundAmount);
      this.RefundData.ChequeNo = this.RefundData.ChequeNo;
      this.RefundData.ChequeDate = this.RefundData.ChequeDate;
      this.RefundData.FK_ChqBankId = this.RefundData.FK_ChqBankId;
      this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
      this.RefundData.IsActive = 1;
      if (this.RefundData.PK_RefundId == null || this.RefundData.PK_RefundId == undefined) {
        this.RefundData.PK_RefundId = 0;
      }
      this.RefundData.Fk_BillId = this.data.billId;
      this.RefundData.receiptNoFull = "";
      if ((this.RefundData.CurrencyAmount >= this.RefundData.RefundAmount) && this.RefundData.RefundAmount > 0) {

        if (this.screenPermissionobj?.modifyPermission == true) {
          this.showspinner = true;
          this.dashboardService.subscriptions = this.billingservice.addRebillfundDetails(this.RefundData).subscribe(data =>
            this.success_refund_response(data), err => this.err_refund_response(err));
        } else {
          this.dashboardService.openSnackBar("You have not permission to allow bill refund please connect admin..", "OK");
        }

      } else {
        this.dashboardService.openSnackBar("Please Enter Correct Refund Amount", "OK");
      }

    }
    else {
      this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
    }


  }
  success_refund_response(data) {
    this.buttondisable = true;
    this.showspinner = false;
    if (this.data.appprvaldetail.pK_TranID > 0) {
      this.data.appprvaldetail.approvedAmount = 0;
      this.RefundData.RefundAmount = 0;
    }
    this.setBillrefunddata(this.data);
    this.getBillrefundList(0, this.data.billId);
    this.dashboardService.openSnackBar("Successfully refund Amount", "OK");
  }
  err_refund_response(err) {
    this.buttondisable = true;
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //set refund data
  selectRefunddata(id) {

    const rowrefunddata = this.RefundDataArray.filter(item => item.pK_RefundId == id);
    if (rowrefunddata[0].fK_PayTypeId != null && rowrefunddata[0].fK_PayTypeId != undefined) {
      this.chnagePaymentMode(rowrefunddata[0].fK_PayTypeId)
    }
    this.dyanmiccheck = false;
    this.RefundData.PK_RefundId = rowrefunddata[0].pK_RefundId;
    this.RefundData.ReferenceNo = rowrefunddata[0].referenceNo;
    this.RefundData.RefundDate = this.datePipe.transform(rowrefunddata[0].refundDate, "yyyy-MM-dd");
    this.RefundData.RefundTime = rowrefunddata[0].refundTime;
    this.RefundData.CurrencyAmount = rowrefunddata[0].currencyAmount;
    this.RefundData.FK_BranchId = rowrefunddata[0].fK_BranchId;
    this.RefundData.RefundAmount = rowrefunddata[0].refundAmount;
    this.RefundData.FK_PayTypeId = rowrefunddata[0].fK_PayTypeId;
    this.RefundData.RefundType = rowrefunddata[0].refundType;
    this.RefundData.ChequeNo = rowrefunddata[0].chequeNo;
    this.RefundData.ChequeDate = this.datePipe.transform(rowrefunddata[0].chequeDate, "yyyy-MM-dd");
    this.RefundData.FK_ChqBankId = rowrefunddata[0].fK_ChqBankId;
    this.RefundData.RefundReason = rowrefunddata[0].refundReason;
    this.RefundData.ConvertRetio = rowrefunddata[0].convertRetio;
    this.RefundData.FK_CreatedById = rowrefunddata[0].fK_CreatedById;
    this.RefundData.FK_CurrencyId = rowrefunddata[0].fK_CurrencyId
    this.RefundData.FK_ReceiptId = 0;
    this.RefundData.Fk_BillId = this.data.billId;
    this.RefundId = id;
  }


  chnagePaymentMode(e) {

    var value = e;
    if (value == 2 || value == 3 || value == 6) {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      this.RefundData.ReferenceNo = null;
      this.show = true;
    } else if (value == 4 || value == 5 || value == 7 || value == 8) {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Transaction No.";
      this.bankdetailelvel2 = "Transaction Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      this.RefundData.ReferenceNo = null;
      if (value == 7) {
        this.show = false;
      } else {
        this.show = true;
      }
    }
    else {
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      this.RefundData.ReferenceNo = null;
      this.dyanmiccheck = false;
      this.show = true;
    }

  }
  // row check color and uncheck 
  rowClicked: any;
  changeTableRowColor(idx: any) {

    if (this.rowClicked === idx) {
      this.RefundData = {};
      this.isupdate = false;
      this.lockfield = true;
      this.rowClicked = -1;
      this.dyanmiccheck = false;
      this.refunddisable = false;
      this.setBillrefunddata(this.data);
      this.getBillrefundList(0, this.data.billId);
      //  this.updaterefund = true;
    }
    else {
      this.rowClicked = idx;
      this.isupdate = true;
      this.lockfield = false;
      this.refunddisable = true;
      //this.updaterefund = false;
    }
  }
  editbillingform() {
    if (this.screenPermissionobj?.modifyPermission === true) {
      document.getElementById("BillingrefundModel").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }
  }
  billRefundupdateresons(a: any) {

    if (this.getRefundReson) {
      this.RefundData.RefundReason = this.getRefundReson;
      this.lockfield = true;
      this.updaterefund = false;
      document.getElementById("BillingrefundModel").style.display = "none";
    } else {
      this.dashboardService.openSnackBar("Please Write your Reason", "OK");
    }

  }
  closeModificationModalDialog() {

    this.lockfield = false;
    document.getElementById("BillingrefundModel").style.display = "none";
  }

  // update refund amount

  updatebillRefunddetails(recid: any) {

    if (this.RefundData.RefundReason) {
      if (this.RefundData.FK_PayTypeId > 1 && this.RefundData.FK_PayTypeId != 7) {
        if ((this.RefundData.ChequeNo == null || this.RefundData.ChequeNo == "") || (this.RefundData.ChequeDate == null || this.RefundData.ChequeDate == "") || (this.RefundData.FK_ChqBankId == null || this.RefundData.FK_ChqBankId == "")) {
          this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
          return;
        }
      } else if (this.RefundData.FK_PayTypeId == 7) {
        if ((this.RefundData.ChequeNo == null || this.RefundData.ChequeNo == "") || (this.RefundData.ChequeDate == null || this.RefundData.ChequeDate == "")) {
          this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
          return;
        }
      }
      if (this.RefundDataArray.length > 1) {
        const filterdata = this.RefundDataArray.filter(item => item.pK_RefundId != this.RefundData.PK_RefundId);
        if (filterdata.length > 0) {
          var tamount = 0
          filterdata.forEach(data => {
            tamount = tamount + data.refundAmount;
          })
          var checkupdateamount = this.RefundData.CurrencyAmount - tamount;
        }
        if (checkupdateamount >= this.RefundData.RefundAmount && this.RefundData.RefundAmount > 0) {
          this.dashboardService.subscriptions = this.billingservice.addRebillfundDetails(this.RefundData).subscribe(data =>
            this.success_updaterefund_response(data), err => this.err_refund_response(err));
        } else {
          this.dashboardService.openSnackBar("Please Enter Correct Refund Amount", "OK");
        }

      } else {
        if ((this.RefundData.CurrencyAmount >= this.RefundData.RefundAmount) && this.RefundData.RefundAmount > 0) {
          this.dashboardService.subscriptions = this.billingservice.addRebillfundDetails(this.RefundData).subscribe(data =>
            this.success_updaterefund_response(data), err => this.err_refund_response(err));
        } else {
          this.dashboardService.openSnackBar("Please Enter Correct Refund Amount", "OK");
        }

      }
    } else {
      this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
    }


  }
  //change payment mode 
  success_updaterefund_response(data) {
    this.updaterefund = true;
    this.isupdate = false;
    this.lockfield = false;
    this.rowClicked = -1;
    this.dyanmiccheck = false;
    this.setBillrefunddata(this.data);
    this.getBillrefundList(0, this.data.billId);
    this.dashboardService.openSnackBar("Successfully Updated", "OK");
  }
  getproductmasterconfig() {

    let BranchId = this.authService.Loggeduser.branchid;
    this.dashboardService.subscriptions = this.billingservice.getproductionConfrigration(BranchId).subscribe(data => {
      //console.log('master confrigartion',data);
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.propertyName === "WebURL") {
          this.reporturl = element.propertyValue;
        }

      }
    })
  }
  reporturl(reporturl: any) {
    throw new Error('Method not implemented.');
  }
  prientRefund() {
    if (this.RefundId) {
      window.open(this.reporturl + 'Refund.aspx?RefundId=' + this.RefundId + '&BranchId=' + this.authService.Loggeduser.branchid + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&PageHeadWebReport=' + 'Y');
    }
    else {
      this.dashboardService.openSnackBar("Please Select Refund Receipt ", "OK");
    }


  }
  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.dashboardService.subscriptions = this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    })
  }
  printTimeline() {

    let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Credit Note' && item.printType == 'NetramReport');
    if (checkreporttype.length > 0) {
      this.prientRefund();
    } else {
      this.printTimelinedata();
    }

  }
  printTimelinedata() {
    if (this.RefundId > 0) {
      let payload = {
        "WebReportPrintMaster": {
          "module": "Billing",
          "printOption": "Credit Note",
          "printType": "WebNetramReport",
          "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
          "PrintTime": this.convertTime12Hour(new Date()),
          "Pk_RegId": this.opdvisitService.patientdetails.pkRegId,
          "Pk_BillId": this.data.billId,
          "Pk_BranchId": this.authService.Loggeduser.branchid,
          "Pk_LoggedUserId": this.authService.Loggeduser.userid,
          "Pk_ReceiptId": this.RefundData.FK_ReceiptId,
          "Pk_RefundId": this.RefundId,
          "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
          "LINE1": this.branchmansterObj.line1,
          "LINE2": this.branchmansterObj.line2,
          "LINE3": this.branchmansterObj.line3,
          "LINE4": this.branchmansterObj.line4,
          "HOSPITALIMAGE": window.location.origin + '/' + this.authService.loginclientlogo,
          "COMPANYIMAGE": window.location.origin + '/' + this.authService.leftbottomlogosm,
          "CERTIFICATE1IMAGE": window.location.origin + '/' + + this.authService.nabhlogo,
          "CERTIFICATE2COMPANYIMAGE": '',
          "RefundArray": 'Y',
          "PatientRegistrationArray": 'Y',
          "PrintHeaderArray": 'Y',
        }

      }

      this.dashboardService.subscriptions = this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
        if (x.length > 0) {
          let printContents, popupWin;
          printContents = x[0].printTemplate;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
          popupWin.document.open();
          popupWin.document.write(`
        <html>
         
      <body onload="window.print()">${printContents}
      </body>
        </html>`
          );

          popupWin.document.close();


        } else {
          this.dashboardService.openSnackBar("Report Template Not Set", "OK");
        }
      }, err => {
        this.dashboardService.openSnackBar("Api Failed", "OK");
      })
    } else {
      this.dashboardService.openSnackBar("Please Select Id", "OK");
    }
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour >= 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }
  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
}
